module.exports = __webpack_public_path__ + "static/media/blog2.6a8a9fea.png";